// Route href vocabulary of the Post Closing edit drawer (`post-closing/<sectionHref>`), kept
// import-light so non-page consumers (e.g. the loanNavigation service) can read the route
// contract without pulling the drawer's form configs (mirrors the Closing EditDrawer.hrefs).
// EditDrawer.config re-exports it.
export const SECTION_HREF_MAP = {
  INVESTOR: 'investor-information',
  ACCOUNTING: 'accounting-information',
  SERVICER: 'servicer-information',
  MERS: 'mers-information',
  SHIPPING: 'shipping-information',
  PAYMENT: 'payment-information',
  FINAL_DOCUMENTS: 'final-documents',
  SHIPPER_MILESTONE: 'shipper-milestone',
  FLIPPED_UNSALABLE: 'flipped-unsalable',
};
